var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"login-page-container"}},[_c('LoginCard')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }